export enum AnswersEnum {
  YES = 'Yes',
  NO = 'No',
}
